var GondelBaseComponent = /** @class */ (function () {
    function GondelBaseComponent(domNode, componentName) {
    }
    /**
     * Stop method
     */
    GondelBaseComponent.prototype.stop = function () { };
    return GondelBaseComponent;
}());
export { GondelBaseComponent };
//# sourceMappingURL=GondelComponent.js.map